import { renderRoutes } from 'react-router-config';
import routes from 'stores/routes';
import { hot } from 'react-hot-loader/root';

const RenderRoutes = () => {
    return renderRoutes(routes);
};

export default hot(RenderRoutes);
